import { render, staticRenderFns } from "./like-comm-button.vue?vue&type=template&id=7727b9e8&"
import script from "./like-comm-button.vue?vue&type=script&lang=js&"
export * from "./like-comm-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports